import { InsuranceUsage } from './ClaimData'
import { ApplyInsuranceMemberPayload, ClaimRecordStatus } from './ClaimRecord'

export const enum InsuranceMemberStep {
  INIT = 'INIT',
  FIND_MEMBER = 'FIND_MEMBER',
  APPLY_INSURANCE = 'APPLY_INSURANCE',
  MEMBER_FOUND = 'MEMBER_FOUND',
  RESTRICTED = 'RESTRICTED',
  UNKNOWN = 'UNKNOWN',
}

export type InsuranceMemberStepPayload = {
  step: InsuranceMemberStep
}

export type InsuranceMemberStepState = InsuranceMemberStepPayload

export type ChangeInsuranceStatusRequest = {
  claimRecordId: string
  useInsuranceStatus: InsuranceUsage
}

export type FindMemberPageState = {
  insurerId?: string
  attemptsRemaining?: number
}

export type ApplyInsurancePageState = {
  memberPayload?: ApplyInsuranceMemberPayload
  claimRecordId?: string
  claimRecordStatus?: ClaimRecordStatus
}
